module.exports = __webpack_public_path__ + "img/heritage.cd6cc810.png";